import { BookmarkIndicator } from '@/components/BookmarkIndicator'
import { DataColumn } from '@/components/Table/TableHead'
import { Alignment } from '@/components/Table/tableHelper'
import { TflMeta, TflStatus } from '@/features/view-tfl-uploaded/types'

const getStatusLabel = (status: TflStatus, t: (key: string) => string) => {
  const statusMap = {
    [TflStatus.NEW]: t('tflViewer.documentTOC.status.newFile'),
    [TflStatus.IN_REVIEW]: t('tflViewer.documentTOC.status.inReview'),
    [TflStatus.APPROVED]: t('tflViewer.documentTOC.status.approved'),
    [TflStatus.QUERY_RAISED]: t('tflViewer.documentTOC.status.queryRaised'),
    [TflStatus.UNDER_REVISION]: t('tflViewer.documentTOC.status.underRevision'),
  }
  return statusMap[status] || status
}

export type TflMetaWithRowNumber = Partial<TflMeta> & { rowNumber?: number }

export const createDocumentTOCColumns = (
  t: (key: string) => string
): DataColumn<TflMetaWithRowNumber>[] => {
  return [
    {
      id: 'rowNumber',
      label: t('tflViewer.documentTOC.columns.number'),
      width: 80,
      align: Alignment.LEFT,
      alignLabel: Alignment.LEFT,
      renderCell: (value: number | undefined) => (
        <span className="text-sm text-gray-900">{value}</span>
      ),
    },
    {
      id: 'displayName',
      label: t('tflViewer.documentTOC.columns.fileName'),
      width: 600,
      align: Alignment.LEFT,
      alignLabel: Alignment.LEFT,
      renderCell: (value: string | undefined, row: TflMetaWithRowNumber) => (
        <div className="flex items-center gap-2 min-w-0">
          <span className="text-sm text-gray-900 truncate" title={value}>
            {value}
          </span>
          {row.is_bookmarked && (
            <BookmarkIndicator className="h-4 w-4 flex-shrink-0 text-foreground-fg-quaternary-400" />
          )}
        </div>
      ),
    },
    {
      id: 'status',
      label: t('tflViewer.documentTOC.columns.status'),
      width: 180,
      align: Alignment.LEFT,
      alignLabel: Alignment.LEFT,
      renderCell: (value: TflStatus | undefined) =>
        value ? getStatusLabel(value, t) : '-',
    },
  ] as DataColumn<TflMetaWithRowNumber>[]
}
